module.exports = __webpack_public_path__ + "media/components/assets/img/icons/bulb-yellow-50f01777004c10b8afc14f3d29574876.svg";